import React, { useEffect, useState } from "react";
import { Grid, Button, IconButton, Checkbox, Menu, MenuItem, CircularProgress } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ManageTemplatesOrDraftsModal from "./BottomToolbarComponents/ManageTemplatesOrDraftsModal";
import ManageAccountsModal from "./BottomToolbarComponents/ManageAccountsModal";
import ScheduleSendModal from "./BottomToolbarComponents/ScheduleSendModal";
import TemplateModal from "./BottomToolbarComponents/TemplateModal";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import styled from "styled-components";
export const BottomToolbar = ({
  templates,
  timezones,
  populate,
  from_emails,
  deleteAccount,
  reconnectAccount,
  disconnectAccount,
  deleteTemplate,
  create,
  addAccount,
  setChange,
  change,
  preview,
  store,
  showAlert,
  drafts,
  toggleNewTemplate,
  mailData,
  setMailData,
  isLoadingFetchDrafts,
}) => {
  const [bottomToolbarStates, setBottomToolbarStates] = useState({
    anchorEl: null,
    anchorEl_2: null,
    openManageTemplateModal: false,
    openDraftsModal: false,
    isScheduleSendModal: false,
    isTemplateModal: false,
  });

  const timeMenu = Boolean(bottomToolbarStates.anchorEl_2);
  const open = Boolean(bottomToolbarStates.anchorEl);

  const handleMenuIconClick = (event) => {
    setBottomToolbarStates({ ...bottomToolbarStates, anchorEl: event.currentTarget });
  };

  const showTemplateModal = () => {
    setBottomToolbarStates({ ...bottomToolbarStates, isTemplateModal: true, anchorEl: null });
  };

  const showScheduleModal = () => {
    setBottomToolbarStates({ ...bottomToolbarStates, isScheduleSendModal: true, anchorEl_2: null });
  };

  useEffect(() => {
    setChange(!change);
  }, [mailData.openManageAccountModal]);

  return (
    <>
      <ManageTemplatesOrDraftsModal
        bottomToolbarStates={bottomToolbarStates}
        setBottomToolbarStates={setBottomToolbarStates}
        openModal={bottomToolbarStates.openManageTemplateModal}
        templates={templates}
        populate={populate}
        deleteTemplate={deleteTemplate}
        isDrafts={false}
        mailData={mailData}
        setMailData={setMailData}
      />
      <ManageTemplatesOrDraftsModal
        bottomToolbarStates={bottomToolbarStates}
        setBottomToolbarStates={setBottomToolbarStates}
        openModal={bottomToolbarStates.openDraftsModal}
        templates={drafts}
        populate={populate}
        deleteTemplate={() => null}
        isDrafts={true}
        mailData={mailData}
        setMailData={setMailData}
        isLoadingFetchDrafts={isLoadingFetchDrafts}
      />
      <ManageAccountsModal
        from_emails={from_emails}
        reconnectAccount={reconnectAccount}
        disconnectAccount={disconnectAccount}
        deleteAccount={deleteAccount}
        addAccount={addAccount}
        store={store}
        showAlert={showAlert}
        mailData={mailData}
        setMailData={setMailData}
      />
      <TemplateModal
        templates={templates}
        populate={populate}
        mailData={mailData}
        openModal={bottomToolbarStates.isTemplateModal}
        setMailData={setMailData}
        bottomToolbarStates={bottomToolbarStates}
        setBottomToolbarStates={setBottomToolbarStates}
      />
      <ScheduleSendModal
        bottomToolbarStates={bottomToolbarStates}
        setBottomToolbarStates={setBottomToolbarStates}
        mailData={mailData}
        setMailData={setMailData}
        timezones={timezones}
      />
      <StyledGrid container>
        <Grid item style={{ margin: "0 10px" }}>
          <Button
            className="send-btn"
            onClick={() => create()}
            variant="contained"
            color="primary"
            size="small"
          >
            {mailData.check ? "Schedule" : "Send"} {mailData.isBulkMailSending && <CircularProgress style={{marginLeft: "5px"}} size={18} color="inherit" />}
          </Button>
        </Grid>
        <Grid item style={{ margin: "0 10px" }}>
          <Button
            style={{ boxShadow: "none" }}
            variant="contained"
            color="default"
            size="small"
            onClick={preview}
          >
            Preview {mailData.isPreviewLoading && <CircularProgress style={{marginLeft: "5px"}} size={18} color="inherit" />}
          </Button>
        </Grid>
        <Grid item style={{ flex: "1" }}></Grid>
        <Grid item>
          <StyledIconButtons
            aria-label="more"
            id="long-button"
            aria-controls="long-menu"
            aria-expanded={timeMenu ? "true" : undefined}
            aria-haspopup="true"
            onClick={(e) => {
              setBottomToolbarStates({ ...bottomToolbarStates, anchorEl_2: e.target });
            }}
          >
            <AccessTimeIcon />
          </StyledIconButtons>
          <Menu
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={bottomToolbarStates.anchorEl_2}
            open={timeMenu}
            onClose={() => {
              setBottomToolbarStates({ ...bottomToolbarStates, anchorEl_2: null });
            }}
          >
            <MenuItem onClick={showScheduleModal}>Schedule Send</MenuItem>
          </Menu>
        </Grid>
        <Grid item>
          <StyledIconButtons
            onClick={() => {
              setMailData({ ...mailData, openManageAccountModal: true });
            }}
          >
            <AccountCircleIcon />
          </StyledIconButtons>
        </Grid>
        <Grid item>
          <StyledIconButtons
            aria-label="more"
            id="long-button"
            aria-controls="long-menu"
            aria-expanded={open ? "true" : undefined}
            aria-haspopup="true"
            onClick={handleMenuIconClick}
          >
            <MoreVertIcon />
          </StyledIconButtons>
          <Menu
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={bottomToolbarStates.anchorEl}
            open={open}
            onClose={() => setBottomToolbarStates({ ...bottomToolbarStates, anchorEl: null })}
          >
            <MenuItem
              onClick={() => setMailData({ ...mailData, saveTemplate: !mailData.saveTemplate })}
            >
              <Grid container alignItems="center">
                <Grid item>Save Template</Grid>
                <Checkbox checked={mailData.saveTemplate} />
              </Grid>
            </MenuItem>
            <MenuItem onClick={showTemplateModal}>Select from template</MenuItem>
            {mailData.selectedFromEmail && (
              <MenuItem
                onClick={() => {
                  setBottomToolbarStates({
                    ...bottomToolbarStates,
                    openDraftsModal: true,
                    anchorEl: null,
                  });
                }}
              >
                Select from gmail draft
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                setBottomToolbarStates({
                  ...bottomToolbarStates,
                  openManageTemplateModal: true,
                  anchorEl: null,
                });
              }}
            >
              Manage Template
            </MenuItem>
            {mailData.selectedFromEmail && (
              <MenuItem
                onClick={() => {
                  toggleNewTemplate();
                  setBottomToolbarStates({ ...bottomToolbarStates, anchorEl: null });
                }}
              >
                New Template
              </MenuItem>
            )}
          </Menu>
        </Grid>
      </StyledGrid>
    </>
  );
};

export default BottomToolbar;

const StyledIconButtons = styled(IconButton)`
  && {
    color: #72757a;
    font-size: 1.5rem;
    cursor: pointer;
  }
`;

const StyledGrid = styled(Grid)`
  && {
    padding: "10px 2px 10px 20px";
    alignitems: "center";
  }
`;
